import React from 'react';

import '../../../../styles/Navigation.css';
import { getAppEnv } from '../../../../../config/env';
import { crawlerDuplicateAvoidStyle } from '../../../../utils/commonUtils';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;
const Navigation = () => {
  return (
    <div style={crawlerDuplicateAvoidStyle} className="mobileShowFlex navOuter">
      <div className="wrapper">
        <h2>Kumbh Mela 2021</h2>
        <img loading="lazy" src={`${PUBLIC_URL}/src/styles/images/header.png`} alt="" />
      </div>
    </div>
  );
};

export default Navigation;
